import React from "react";
import SendFeedbackModal from "../modals/SendFeedbackModal";
import FeedbackForm from "../modals/FeedbackForm";
import FeedbackModal from "../modals/FeedbackModal";

const RadioButton = ({ label, checked }) => (
  <div className="form-check">
    <input className="form-check-input ml-1" type="radio" checked={checked} disabled />
    <label className="form-check-label">{label}</label>
  </div>
);

const FileTable = ({ fileUploads }) => (
  <table className="table">
    <thead>
      <tr>
        <th>Title</th>
        <th>File Name</th>
        <th>Upload Accepted</th>
        <th>Upload Rejected</th>
      </tr>
    </thead>
    <tbody>
      {fileUploads.map((file) => (
        <tr key={file.id}>
          <td>{file.name}</td>
          <td>
            <a href={file.asset_url} target="_blank" rel="noopener noreferrer">
              {file.asset_file_name}
            </a>
          </td>
          <td><RadioButton checked={file.reviews?.[0]?.status === "accepted"} /></td>
          <td><RadioButton checked={file.reviews?.[0]?.status === "declined"} /></td>
        </tr>
      ))}
    </tbody>
  </table>
);

const FormSubmissionDetail = ({ submission, organizationName, affiliateMemberId, currentUser, onEdit }) => {
  const review = submission.reviews?.[0];
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [feedbacks, setFeedbacks] = React.useState(submission.feedbacks || []);

  return (
    <div>
      <div className="d-flex justify-content-between">
        <a
          href={`/organizations/${organizationName}/forms/${submission.form.token}/submissions/${submission.uuid}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>{submission.form.title}</h4>
        </a>

        <button
          className="btn btn-primary"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(submission.id);
          }}
        >
          Edit
        </button>
      </div>

      <div className="d-flex gap-3 mt-3">
        <button className="btn btn-primary" onClick={() => setModalOpen(true)}>
          Send Feedback
        </button>

        {feedbacks?.length > 0 && (
          <>
            <button
            className="btn btn-primary ml-3"
            onClick={() => setShowModal(true)}
            >
              View Feedback
            </button>

            <FeedbackModal
              show={showModal}
              onClose={() => setShowModal(false)}
              submissionId={submission.id}
              organizationName={organizationName}
              affiliateMemberId={submission.submissionable_id}
            />
          </>
        )}

        <SendFeedbackModal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
          <FeedbackForm
            submission={submission}
            affiliateMemberId={submission.submissionable_id}
            organizationName={organizationName}
            currentUser={currentUser}
            onClose={() => setModalOpen(false)}
            onFeedbackAdded={(newFeedback) => setFeedbacks((prev) => [...prev, newFeedback])}
          />
        </SendFeedbackModal>
      </div>

      <div className="row mt-3">
        <div className="col-md-2">
          <b>Submitted Date</b>
          <div>{submission.submitted_at ? new Date(submission.submitted_at).toLocaleDateString() : 'Draft'}</div>
        </div>

        <div className="col-md-2">
          <b className="d-block">Form Accepted?</b>
          <RadioButton label="Accepted" checked={review?.status === "accepted"} />
          <RadioButton label="Rejected" checked={review?.status === "declined"} />
        </div>

        <div className="col-md-6">
          <b>Notes</b>
          <textarea className="form-control" value={review?.notes || ''} readOnly />
        </div>
      </div>

      <div className="mt-4">
        <b>File Uploads</b>
        <FileTable fileUploads={submission.file_uploads || []} />
      </div>
    </div>
  );
};

export default FormSubmissionDetail;
